window.theme = window.theme || {};

(function($){
  var $ = jQuery = $;

  $(function() {

    

      

	$('body').find('#cartform').each(function() {
      new theme.CheckStoreNumber($(this), {
        namespace: '#cartform'
      });
    });





    





  });

  theme.config = {
    BASE_URL:'https://ipcsubway.thegenielab.net/'
  };


  theme.genie = {
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    checkStoreNumberApi: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType:"json",
      });
    },
    addProductToOrder: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType:"json",
      });
    },
    saveForm: function(data,url) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        crossDomain: true
      });
    },
   

    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    
  }
  
    theme.CheckStoreNumber = (function() {
    var classes = {
      input: '.validatestoreNum',
    };

    function CheckStoreNumber($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);

      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };

      this.options = $.extend(defaults, options);

      this.initEventListeners();
    };

    CheckStoreNumber.prototype = $.extend({}, CheckStoreNumber.prototype, {
      initEventListeners: function() {
        this.$input.on('blur', function() {
          	
			//console.log(this.$input.val());
          var url = theme.config.BASE_URL+'json/'+this.$input.val();
      	var data = [];
          //console.log(url);
      	theme.genie.checkStoreNumberApi(url).then(this.displayValues.bind(this));

        }.bind(this));
      },

      

	  displayValues: function(response) {
     	//console.log(response);
        $("#store_number_container").find(".error").html("");
        $("#store_number_container").find(".error").hide();
        var restrictedCheckout = response.restrictedCheckout;
        if(response.status){
          
          if(restrictedCheckout == true || restrictedCheckout == "true"){
            $('#store_number_validation').val('not-authorized');
            $("input[name='checkout']").each(function(){
              $(this).hide();
            });
            //alert('You are not allowed to proceed');
           	$("#store_number_container").find(".error").html("This store number is not authorized to rent a POS system.  Please email <strong>RestaurantTechnology@ipcoop.com</strong> for further instruction");
			$("#store_number_container").find(".error").show();
          }else{
            $('#store_number_validation').val('authorized');
            $("input[name='checkout']").each(function(){
              $(this).show();
              $("#store_number_container").find(".error").html("");
              $("#store_number_container").find(".error").hide();
            });
          }
        }else{
          $('#store_number_validation').val('authorized');
          $("input[name='checkout']").each(function(){
            $(this).show();
            $("#store_number_container").find(".error").html("");
            $("#store_number_container").find(".error").hide();
          });
        }
      },

      
      
      success: function($notificationSelector,$totalSelector) {

		
      },

      error: function(XMLHttpRequest,$notificationSelector) {
        alert(XMLHttpRequest.responseJSON.message);
      }
    });

    return CheckStoreNumber;
  })();


})(jQuery);